module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_03.7336099b.jpg";